<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="1200px" @close="closeDialog">
    <div class="procurement">
      <!-- 表格 -->
      <div class="main-content">
        <vxe-toolbar>
          <template v-slot:buttons>
            <vxe-button
              @click="confirm()"
              type="primary"
              size="medium"
              icon="el-icon-plus"
              class="vxe-btn-primary"
              >确认</vxe-button
            >
          </template>
        </vxe-toolbar>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane name="first" :label="title">
            <vxe-grid
              v-if="ladingVisible"
              border
              show-overflow
              resizable
              ref="table"
              class="vxe-table-element"
              size="mini"
              align="left"
              max-height="400px"
              :auto-resize="true"
              :data="tableData"
              :columns="salesListColumn"
              :edit-config="{ trigger: 'click', mode: 'row' }"
              column-min-width="120"
            >
            </vxe-grid>
            <vxe-grid
              v-else
              border
              show-overflow
              resizable
              ref="table"
              class="vxe-table-element"
              size="mini"
              align="left"
              max-height="400px"
              :auto-resize="true"
              :data="tableData"
              :columns="columnList"
              :edit-config="{ trigger: 'click', mode: 'row' }"
              column-min-width="120"
            >
            </vxe-grid>
          </el-tab-pane>
          <el-tab-pane v-if="!ladingVisible" name="second" label="委托加工入库单">
            <vxe-grid
              border
              show-overflow
              resizable
              ref="tableMc"
              class="vxe-table-element"
              size="mini"
              align="left"
              max-height="400px"
              :auto-resize="true"
              :data="tableDataMc"
              :columns="columnListMc"
              :edit-config="{ trigger: 'click', mode: 'row' }"
              column-min-width="120"
            >
            </vxe-grid>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  import API from '@/api/financeCenter/withholding';
  // import SiruiSearch from '@/components/SiruiSearch';
  import { filterEmpty } from '@/common/js/util';
  // import InputNumber from '@/components/form-item/input-number';
  export default {
    name: 'accruedDetail',
    components: {
      // InputNumber,
      // SiruiSearch,
    },
    props: ['accruedInfo'],
    computed: {
      columnList() {
        return [
          { type: 'checkbox', width: 50, checked: true }, // checkbox
          {
            field: 'businessInboundNo',
            title: this.$t('withholdingList.column.inboundNo'),
            visible: true,
            width: 120,
          }, //业务入库单号
          {
            field: 'businessInboundBatchNo',
            title: this.$t('withholdingList.column.businessInboundBatchNo'),
            visible: true,
            width: 120,
          }, //业务入库批次号
          {
            field: 'contractNo',
            title: this.$t('withholdingList.withholdInfoAdd.column.contractNo'),
            visible: true,
            width: 120,
          }, //采购合同号
          {
            field: 'contractDetailNo',
            title: this.$t('withholdingList.withholdInfoAdd.column.contractDetailNo'),
            visible: true,
            width: 120,
          }, //采购合同行号
          {
            field: 'inboundQuantity',
            title: this.$t('withholdingList.inboundLine.table.inboundQuantity'),
            visible: true,
            width: 80,
          }, //入库数量
          {
            //业务结算单价
            field: 'businessVariablePrice',
            title: this.$t('withholdingList.column.priceWithTax'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.businessVariablePrice)}</span>,
                ];
              },
            },
            visible: true,
            width: 100,
          },
          {
            //不含税单价
            field: 'businessVariablePriceWithoutTax',
            title: this.$t('withholdingList.column.priceWithoutTax'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.businessVariablePriceWithoutTax)}
                  </span>,
                ];
              },
            },
            visible: true,
            width: 100,
          },
          {
            field: 'businessVariablePricePureAmount',
            title: this.$t('withholdingList.column.purePrice'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.businessVariablePricePureAmount)}
                  </span>,
                ];
              },
            },
            visible: true,
            width: 120,
          }, //业务结算价净值
          {
            //业务结算价含税金额
            field: 'businessVariablePriceWithTax',
            title: this.$t('withholdingList.column.amountWithTax'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.businessVariablePriceWithTax)}
                  </span>,
                ];
              },
            },
            visible: true,
            width: 130,
          },
          {
            //业务结算价税额
            field: 'businessVariablePriceTaxAmount',
            title: this.$t('withholdingList.column.taxAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.businessVariablePriceTaxAmount)}
                  </span>,
                ];
              },
            },
            visible: true,
            width: 120,
          },
          {
            field: 'taxRate',
            title: this.$t('withholdingList.column.taxRate'),
            visible: true,
            width: 60,
          }, //税率
          {
            field: 'storageNo',
            title: this.$t('withholdingList.column.storageNo'),
            visible: true,
            width: 80,
          }, //仓库编码
          {
            field: 'storageName',
            title: this.$t('withholdingList.column.storageName'),
            visible: true,
            width: 80,
          }, //仓库名称
          {
            field: 'productNo',
            title: this.$t('withholdingList.column.productNo'),
            visible: true,
            width: 80,
          }, //物料描述
          {
            field: 'productDesc',
            title: this.$t('withholdingList.column.productDesc'),
            visible: true,
            width: 80,
          }, //物料描述
        ];
      },
      salesListColumn() {
        return [
          { type: 'checkbox', width: 50 }, // checkbox
          {
            field: 'contractNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.contractNo'),
            visible: true,
            width: 120,
          }, //销售合同号
          {
            field: 'contractDetailNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.contractDetailNo'),
            visible: true,
            width: 120,
          }, //销售合同行号
          {
            field: 'customerName',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.customerName'),
            visible: true,
            width: 120,
          }, //客户
          {
            field: 'ladingNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.ladingNo'),
            visible: true,
            width: 120,
          }, //提单号
          {
            field: 'ladingDetailNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.ladingDetailNo'),
            visible: true,
            width: 120,
          }, //提单行号
          {
            field: 'ladingQuantity',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.ladingQuantity'),
            visible: true,
            width: 120,
          }, //提单数量
          {
            field: 'actualSendQuantity',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.actualSendQuantity'),
            visible: true,
            width: 120,
          }, //实发数量
          {
            field: 'businessChangingUnitPrice',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.businessChangingUnitPrice'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.businessChangingUnitPrice)}</span>,
                ];
              },
            },
            visible: true,
            width: 120,
          }, //变动单价
          {
            field: 'businessLadingAmount',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.businessLadingAmount'),
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.businessLadingAmount)}</span>,
                ];
              },
            },
            visible: true,
            width: 120,
          }, //提单金额
          {
            field: 'storageNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.storageNo'),
            visible: true,
            width: 120,
          }, //仓库编码
          {
            field: 'storageName',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.storageName'),
            visible: true,
            width: 120,
          }, //仓库名称
          {
            field: 'productNo',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.productNo'),
            visible: true,
            width: 120,
          }, //物料编码
          {
            field: 'productDesc',
            title: this.$t('withholdingList.withholdInfoAdd.salesCloumn.productDesc'),
            visible: true,
            width: 120,
          }, //物料描述
        ];
      },

      columnListMc() {
        return [
          { type: 'checkbox', width: 50, checked: true }, // checkbox
          { field: 'inboundNo', title: '委托加工入库单号', visible: true, width: 120 }, //业务入库单号
          {
            field: 'inboundBatchNo',
            title: this.$t('withholdingList.column.businessInboundBatchNo'),
            visible: true,
            width: 120,
          }, //业务入库批次号
          { field: 'contractNo', title: '委托加工合同号', visible: true, width: 120 }, //采购合同号
          { field: 'contractDetailNo', title: '委托加工合同行号', visible: true, width: 120 }, //采购合同行号
          {
            field: 'inboundQuantity',
            title: this.$t('withholdingList.inboundLine.table.inboundQuantity'),
            visible: true,
            width: 80,
          }, //入库数量
          {
            //加工费单价
            field: 'businessContractPrice',
            title: '加工费单价',
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.businessContractPrice)}</span>,
                ];
              },
            },
            visible: true,
            width: 100,
          },
          {
            //不含税产成品结算价
            field: 'settlementPrice',
            title: '不含税产成品结算价',
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.settlementPrice)}</span>];
              },
            },
            visible: true,
            width: 100,
          },
          //含税产成品总金额
          {
            field: 'productAmountWithTax',
            title: '含税产成品总金额',
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.productAmountWithTax)}</span>,
                ];
              },
            },
            visible: true,
            width: 120,
          },
          {
            //产成品税率
            field: 'productTaxRate',
            title: '产成品税率',
            visible: true,
            width: 130,
          },
          {
            //不含税产成品总金额
            field: 'settlementAmount',
            title: '不含税产成品总金额',
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.settlementAmount)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          //产成品税额
          {
            field: 'productTaxAmount',
            title: '产成品税额',
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.productTaxAmount)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          //含税加工费总金额
          {
            field: 'mcAmountWithTax',
            title: '含税加工费总金额',
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.mcAmountWithTax)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          //加工费税率
          {
            field: 'taxRate',
            title: '加工费税率',
            visible: true,
            width: 120,
          },
          //不含税加工费总金额
          {
            field: 'mcAmountWithoutTax',
            title: '不含税加工费总金额',
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.mcAmountWithoutTax)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          //加工费税额
          {
            field: 'mcTaxWithout',
            title: '加工费税额',
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.mcTaxWithout)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          //不含税原材料总金额
          {
            field: 'materialAmount',
            title: '不含税原材料总金额',
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.materialAmount)}</span>];
              },
            },
            visible: true,
            width: 120,
          },
          { field: 'inboundStorageNo', title: '转入仓库', visible: true, width: 80 }, //仓库编码
          { field: 'inboundStorageName', title: '转入仓库名称', visible: true, width: 80 }, //仓库名称
          { field: 'outboundStorageNo', title: '转出仓库', visible: true, width: 80 }, //仓库编码
          { field: 'outboundStorageName', title: '转出仓库名称', visible: true, width: 80 }, //仓库名称
          {
            field: 'productNo',
            title: this.$t('withholdingList.column.productNo'),
            visible: true,
            width: 80,
          }, //物料描述
          {
            field: 'productDesc',
            title: this.$t('withholdingList.column.productDesc'),
            visible: true,
            width: 80,
          }, //物料描述
        ];
      },
    },
    data() {
      return {
        activeName: 'first',
        dialogVisible: false,
        ladingVisible: false,
        title: this.$t('withholdingList.details.title'),
        tableData: [],
        tableDataMc: [],
      };
    },
    /**页面必要代码Start */
    mounted() {},
    methods: {
      // 弹窗打开时加载界面数据
      openDialog(params) {
        // 预提类型为出口佣金、出口运费
        if (this.accruedInfo.accruedType == 'YT16' || this.accruedInfo.accruedType == 'YT17') {
          this.ladingVisible = true;
          this.title = this.$t('withholdingList.details.ladingTitle');
        } else {
          this.ladingVisible = false;
          this.title = this.$t('withholdingList.details.title');
        }
        this.dialogVisible = true;
        this.activeName = 'first';
        this.getData(params);
        if (!this.ladingVisible) this.getMcData(params);
      },
      closeDialog() {
        // 弹窗关闭
        this.dialogVisible = false;
      },
      handleClick(tab) {
        console.log(tab.name);
      },
      //获取入库明细数据数据
      getData(params) {
        let query = this.setSearchParams(params);
        let api = API.ACCRUED_BUSINESS_INBOUND;
        if (this.ladingVisible) {
          api = API.ACCRUED_SALES_LADING;
        }
        this.$axios.post(api, filterEmpty(query)).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data || [];
          } else {
            this.tableData = [];
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取委托加工入库单
      getMcData(params) {
        let query = {
          inboundStatus: 'MCZT05',
          eqContractNo: params.contractNo,
        };
        let api = API.QUERY_MCINBOUND_PAGE;
        this.$axios.post(api, filterEmpty(query)).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableDataMc = res.data.data.records || [];
          } else {
            this.tableDataMc = [];
            this.$alert(res.data.msg);
          }
        });
      },
      // 查询参数整理
      setSearchParams(params) {
        // 分页数据
        const query = this.query;
        // const result = {};
        if (this.ladingVisible) {
          this.result = Object.assign({}, query, {
            ladingStatus: 'TDZT03',
            contractNo: params.contractNo,
          });
        } else {
          this.result = Object.assign({}, query, {
            inboundStatus: '02',
            eqContractNo: params.contractNo,
            isGreaterThanZero: '2',
          });
        }

        return filterEmpty(this.result);
      },
      // 确认
      confirm() {
        let params = null;
        if (this.activeName == 'first') {
          params = this.$refs.table.getCheckboxRecords().map((item) => {
            return {
              ...item,
              id: null,
            };
          });
        } else if (this.activeName == 'second') {
          params = this.$refs.tableMc.getCheckboxRecords().map((item) => {
            return {
              ...item,
              id: null,
            };
          });
        }
        this.$emit('confirm', params, this.activeName == 'second' ? 'mc' : '');
      },
    },
  };
</script>
